<template>
  <div class="container getting-started">
    <progress-bar :full_length="progress_bar_length" :percentage_complete="33" />
    <div class="sign-up-title">{{ title }}</div>
    <div class="sign-up-explainer">{{ explainer }}</div>
    <div class="error" v-if="error != ''">{{ error }}</div>
    <div class="input-container">
      <fg-input type="text"
                label="Email"
                placeholder=""
                :isRequired=true
                v-model="email"
                @keyup.enter.native="onNextClicked">
      </fg-input>
    </div>
    <div class="button-row row justify-content-center">
      <default-button :buttonText="button_title" v-on:onButtonClicked="onNextClicked" :disabled="hasEmptyField" />
    </div>
    <div class="sign-up-supplemental">{{ supplemental }}</div>
  </div>
</template>

<script>
  import ProgressBar from '@/components/UIComponents/ProgressBar/ProgressBar.vue'
  import DefaultButton from '@/components/UIComponents/Buttons/DefaultButton.vue'

  export default {
    components: {
      ProgressBar,
      DefaultButton,
    },
    data () {
      return {
        error: '',
        progress_bar_length: 400,
        title: 'Getting Started is Easy',
        explainer: 'Enter your email to sign up for your free 30-day trial',
        supplemental: '100% free to get started. No credit card required.',
        email: '',
        button_title: 'NEXT',
        email_regex: /[^@]+@[^@]+\.[^@]+/,
      }
    },
    methods: {
      onNextClicked () {
        if (!this.hasEmptyField) {
          this.checkForErrors()
          if (this.error.length === 0) {
            var payload = {
              step: 'create account',
              email: this.email,
            }

            this.$emit('goTo', payload)
          }
        }
      },
      checkForErrors () {
        this.error = '';
        if (this.email.length === 0) {
          this.error = 'Email is required';
        } else {
          if (!this.email_regex.test(this.email)) {
            this.error = 'Email has an invalid format';
          }
        }
      },
      handleResize () {
        if (window.innerWidth < 992) {
          this.progress_bar_length = window.innerWidth * 0.5;
        } else {
          this.progress_bar_length = 400;
        }
      },
    },
    computed: {
      hasEmptyField () {
        return !this.email_regex.test(this.email)
      },
    },
    mounted () {
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
  }
</script>
